// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"18eded9b","839":"cd2afdb6"}[chunkId] + ".chunk.js";
};